<template>
  <div class="banner_img">
    <img src="../../assets/index.png" />
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      logo: "",
    };
  },
  computed: {},
  methods: {},
  created() {},
};
</script>

<style scoped lang="scss">
.banner_img {
  height: 220px;
  overflow: hidden;
  position: relative;
  img {
    // position:absolute;
    // top: -200px;
    // height: 600;
    width: 100%;
  }
}
</style>
